// src/reducers/claimReducer.js
import {
    FETCH_CLAIMS_LOADING,
    FETCH_CLAIMS_SUCCESS,
    FETCH_CLAIMS_FAILURE,
    UPDATE_CLAIM_LOADING,
    UPDATE_CLAIM_SUCCESS,
    UPDATE_CLAIM_FAILURE
  } from '../Types/claimTypes';
  
  const initialState = {
    loading: false,
    data: [],
    error: null,
    updateLoading: false,
    updateError: null
  };
  
  const claimReducer = (state = initialState, action) => {
    switch (action.type) {
      // Fetch claims
      case FETCH_CLAIMS_LOADING:
        return {
          ...state,
          loading: true,
          error: null
        };
  
      case FETCH_CLAIMS_SUCCESS:
        return {
          ...state,
          loading: false,
          data: action.payload,
          error: null
        };
  
      case FETCH_CLAIMS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload
        };
  
      // Update claim
      case UPDATE_CLAIM_LOADING:
        return {
          ...state,
          updateLoading: true,
          updateError: null
        };
  
      case UPDATE_CLAIM_SUCCESS:
        return {
          ...state,
          updateLoading: false,
          data: state.data.map(claim =>
            claim._id === action.payload._id ? action.payload : claim
          ),
          updateError: null
        };
  
      case UPDATE_CLAIM_FAILURE:
        return {
          ...state,
          updateLoading: false,
          updateError: action.payload
        };
  
      default:
        return state;
    }
  };
  
  export default claimReducer;